<template>
  <div class="fy-head">
    <router-link to="/"><img :src="logo" class="fy-head__logo" /></router-link>
    <div class="fy-head__menu">
      <div
        class="fy-head__menu__item"
        @click="menuClick(item)"
        v-for="item in menuList"
        :key="item.name"
      >
        <div class="fy-head__menu__item__name">
          {{ item.name }}
        </div>
        <div class="fy-head__menu__item__nameZh">
          {{ item.nameZh }}
        </div>
      </div>
    </div>
    <Drawer
      :closable="false"
      v-model="showDrawer"
      :width="340"
    >
      <div class="fy-drawer"  :style="{padding: 0}">
        <div class="fy-drawer__logo">
          <img :src="cpxlIcon" />
        </div>
        <div class="fy-drawer__list">
          <div
            class="fy-drawer__item"
            v-for="item in productList"
            :key="item.name"
            @click="productItemClick(item.type, item.name)"
          >
            <div class="fy-drawer__item__nameZh">{{ item.nameZh }}</div>
            <div class="fy-drawer__item__name">{{ item.name }}</div>
          </div>
        </div>
        <div class="fy-drawer__bottom">
          <img :src="drawerBottomIcon" />
        </div>
      </div>
    </Drawer>
  </div>
</template>

<script>
import Vue from "vue";
import logo from "@/assets/home-logo.png";
import cpxlIcon from "@/assets/cpxl—icon.png";
import drawerBottomIcon from "@/assets/drawer-bottom-icon@3x.png";
export default Vue.extend({
  name: "top-head",
  data() {
    return {
      menuList: [
        {
          name: "品牌介绍",
          nameZh: "ABOUT US",
          url: "/brand",
        },
        {
          name: "产品系列",
          nameZh: "SERIES PRODUCTS",
          showDrawer: true,
          url: "/products",
        },
        {
          name: "品牌合作",
          nameZh: "COLLABORATION",
          url: "/brand_cooperate",
        },
        {
          name: "联系我们",
          nameZh: "CONTACT US",
          url: "/contact_us",
        },
        {
          name: "加入我们",
          nameZh: "JOIN US",
          url: "/join_us",
        },
      ],
      productList: [
        {
          name: "清新系列",
          nameZh: "FRESH COllECTION",
          type: "fresh",
        },
        {
          name: "法式系列",
          nameZh: "FRENCH COllECTION",
          type: "french",
        },
        {
          name: "经典系列",
          nameZh: "CLASSIC COllECTION",
          type: "classic",
        },
        {
          name: "镭射系列",
          nameZh: "LASER COllECTION",
          type: "laser",
        },
        {
          name: "纯色系列",
          nameZh: "PURE COllECTION",
          type: "pure",
        },
        {
          name: "磨砂系列",
          nameZh: "FROSTED COllECTION",
          type: "frosted",
        },
        {
          name: "点钻系列",
          nameZh: "DIAMOND COllECTION",
          type: "diamond",
        },
      ],
      showDrawer: false,
      logo,
      cpxlIcon,
      drawerBottomIcon,
    };
  },
  methods: {
    menuClick(item) {
      if (this.$route.path === '/' && item.url === '/products') {
        this.showDrawer = true;
      } else {
        if(this.$route.path === '/products'){
          this.$router.push({
            path: item.url,
            query: {
              type: 'fresh',
              name: '清新系列'
            }
          });
        }else {
          this.$router.push(item.url);
        }   
      }
    },
    productItemClick(type, name) {
      this.showDrawer = false
      this.$router.push({
        path: '/products',
        query: {
          type,
          name
        }
      })
    }
  },
});
</script>